const TOGGLE_STATES = {
  ALL: 'all',
  DIMENSIONS: 'isDimensionsToggleDisabled',
  SYSTEM_MODE: 'isSystemGeneratedToggleDisabled',
  TABLE: 'isTableToggleDisabled',
};

export default TOGGLE_STATES;
